import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import type { Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  // {
  //   path: 'wizard',
  //   loadChildren: () =>
  //     import('./wizard/wizard.module').then((m) => m.WizardModule),
  // },
  {
    path: 'usage',
    loadChildren: () =>
      import('./usage/usage.module').then((m) => m.UsageModule),
  },
  {
    path: 'chats',
    loadChildren: () =>
      import('./chats/chats.module').then((m) => m.ChatsModule),
  },
  {
    path: 'data-generation',
    loadChildren: () =>
      import('./data-generation/data-generation.module').then(
        (m) => m.DataGenerationModule
      ),
  },
  {
    path: 'models',
    loadChildren: () =>
      import('./models/models.module').then((m) => m.ModelsModule),
  },
  {
    path: 'chatbots',
    loadChildren: () =>
      import('./chatbots/chatbots.module').then((m) => m.ChatbotsModule),
  },
  {
    path: 'support',
    loadChildren: () =>
      import('./support/support.module').then((m) => m.SupportModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
